import { MAX_SECS } from './const';
import _ from 'lodash';
import { dbget, dbdel, dbset } from '../HOME/utils';

const baseKey = props => {
  const { size } = props;
  return `RE • ${size} • `;
};

export const boardKey = props => {
  return `${baseKey(props)}BOARD`;
};

export const statsKey = props => {
  return `${baseKey(props)}STATS`;
};

export const getStats = (props, resolve) => {
  const key = statsKey(props);
  dbget(key, stats => {
    if (!stats) {
      stats = { plays: 0, aggScore: 0, bestScore: 0 };
    }

    resolve(stats);
  });
};

export const getMoreStats = (stats, size, msecs) => {
  let { plays, aggScore, aveScore, bestScore } = stats || {};

  if (!aveScore) {
    aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);
  }

  const score = calcScore(msecs || 0, size);
  const grade = _.round(((aveScore || 0) * Math.min(10, plays || 0)) / 10.0);
  return { plays, aveScore, bestScore, grade, score };
};

export const calcScore = (msecs, size) => {
  if (msecs < 0) {
    return 0;
  }

  const maxSecs = MAX_SECS[size - 1];
  const score = _.round((1000 * maxSecs - msecs) / maxSecs);
  return Math.max(score, 10);
};

export function setStats(props, surrender) {
  dbdel(boardKey(props));

  let { stats, size, msecs } = props;
  let { plays, aggScore, bestScore } = stats || {};

  plays += 1;
  msecs = msecs || 0;
  let score = 0;

  if (surrender) {
    msecs = Math.max(msecs, MAX_SECS[size - 1] * 1000);
  } else {
    score = calcScore(msecs, size);

    if (score === 1000) {
      score = 0;
    }
  }

  aggScore = (aggScore || 0) + score;

  bestScore = Math.max(score, bestScore || 0);

  const key = statsKey(props);
  stats = { plays, aggScore, bestScore };

  dbset(key, stats);
  props.updateStats(stats);
}
